import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: '/videos/',
    exact: true,
    enableLooseEtag: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "video_landing_page" */ '../pages/video-landing/video-landing')
    ),
    chunkName: 'video_landing_page',
  },
  {
    path: '/video-playlist/',
    exact: true,
    enableLooseEtag: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "video_playlist_page" */ '../pages/video-landing/video-playlist-landing')
    ),
    chunkName: 'video_playlist_page',
  },
];
